import {EllipsoidTerrainProvider} from "cesium";
import * as Cesium from 'cesium';
import 'cesium/Build/Cesium/Widgets/widgets.css';
import {memo} from 'react';
import {useLocation} from "react-router";
import {Viewer, Camera} from 'resium';

import {getApiBase} from '../../modules/url';

import {CameraController} from './CameraController';
import OptimizeTerrainLoading from "./OptimizeTerrainLoading";
import {VerticalExaggeration} from './overlay/VerticalExaggeration';
import {RemoveCesiumLogo} from './RemoveCesiumLogo';
import {BorderImageryProvider} from './BorderImageryProvider';
import KmlMap from './KmlMap';
import CameraFlyToCoords, {UpdatePositionProps} from './CameraFlyToCoords';
import InitGlobusController from './InitGlobusController';
import RestrictZoom from "./RestricZoom";
import TileImageryProviders from './TileImageryProviders';
import LabelEntity from './LabelEntity';
import {TerrainScene} from "./overlay/TerrainScene";

Cesium.TrustedServers.add(new URL(getApiBase()).host, 443);

const Globus: React.FC<UpdatePositionProps> = memo(({position, boundingBox}) => {
  Cesium.Ion.defaultAccessToken = ''
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const kmzIdStr = params.get('kmz');
  const kmzId2 = kmzIdStr !== null ? parseInt(kmzIdStr, 10) : null;
  return (
    <Viewer
      className="w-full h-full"
      homeButton={false}
      infoBox={false}
      timeline={false}
      navigationHelpButton={false}
      animation={false}
      baseLayerPicker={false}
      sceneModePicker={false}
      fullscreenButton={false}
      geocoder={false}
      selectionIndicator={false}
      requestRenderMode // Improve performance (https://cesium.com/blog/2018/01/24/cesium-scene-rendering-performance/)
      maximumRenderTimeChange={Infinity} // Never render without requests because we have no animations (e.g. video)
      // Remove Google photorealistic terrain
      terrainProvider={new EllipsoidTerrainProvider()}
      // @ts-expect-error Resium typings don’t declare it
      imageryProvider={false}
    >
      <OptimizeTerrainLoading />
      <RestrictZoom/>
      <TerrainScene />
      <RemoveCesiumLogo />
      <Camera percentageChanged={0.01} />
      <CameraFlyToCoords position={position} boundingBox={boundingBox} kmzId2={kmzId2} />
      <InitGlobusController />
      <CameraController />
      <KmlMap />
      <TileImageryProviders />
      <LabelEntity />
      <VerticalExaggeration />
      <BorderImageryProvider />
    </Viewer>
  );
});

export default Globus;
